import { Form, Row, Col } from 'react-bootstrap';
import { isValidGSTIN } from '../../../common/validators';
import Select from 'react-select';

function BrokerBasicInfoForm({ form, setForm, stepSubmitted }) {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const gstRegistrationOptions = [
        { value: 'registered', label: 'GST Registered' },
        { value: 'URD', label: 'URD (Unregistered Dealer)' },
    ];

    const handleSelectChange = (selectedOption, { name }) => {
        setForm((prev) => ({
            ...prev,
            [name]: selectedOption?.value || '',
        }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>
                            Business Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            name="business_name"
                            value={form.business_name}
                            onChange={handleChange}
                            isInvalid={stepSubmitted && !form.business_name}
                        />
                        <Form.Control.Feedback type="invalid">
                            Business name is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Alias</Form.Label>
                        <Form.Control
                            name="alias"
                            value={form.alias}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2 fs-9">
                        <Form.Label>GST Registration Type</Form.Label>
                        <Select
                            name="gst_registration"
                            value={gstRegistrationOptions.find(opt => opt.value === form.gst_registration)}
                            onChange={handleSelectChange}
                            options={gstRegistrationOptions}
                            placeholder="-- Select GST Type --"
                        />
                    </Form.Group>
                </Col>

                {form.gst_registration === 'registered' && (
                    <Col md={6} xl={4}>
                        <Form.Group className="mb-2">
                            <Form.Label>GSTIN</Form.Label>
                            <Form.Control
                                name="gstin"
                                value={form.gstin}
                                onChange={handleChange}
                                isInvalid={form.gstin && !isValidGSTIN(form.gstin)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Invalid GSTIN format.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                )}

            </Row>
        </div>
    );
}

BrokerBasicInfoForm.validate = function (form) {
     return (
    !!form.business_name
  );
};

export default BrokerBasicInfoForm;
